<template lang="pug">
  .base-details-winner
    .overflow-winner(@click="$root[rootVariable] = false")
    .details-winner(v-if="winner!=null")
      .close
      .congrulations-text ¡FELICITACIONES HAS GANADO UNA MOTO!
      .award
        .bike-content
          img(src="/images/tvs_moto.png")
      .name {{ winner.nombre }}
      .columns
        .column
          .card-details
            .detail-content.matr
              span Matrícula:
              b {{ winner.matricula }}
            .detail-content.dateAdd
              span Fecha de Matrícula:
              b {{ getMatriculaDate }}
            .detail-content.dateCheck
              span Fecha de Renovación:
              b {{ getRenovacionDate }}
            .detail-content.id
              span Identificación:
              b {{ winner.identificacion }}
            .detail-content.phones
              span Telefonos:
              b
                span(v-if="winner.ssiConfecamara.telcom1") {{ winner.ssiConfecamara.telcom2 ? winner.ssiConfecamara.telcom1 + ', ' : winner.ssiConfecamara.telcom1 }}
                span(v-if="winner.ssiConfecamara.telcom2") {{ winner.ssiConfecamara.telcom3 ? winner.ssiConfecamara.telcom2 + ', ' : winner.ssiConfecamara.telcom2 }}
                span(v-if="winner.ssiConfecamara.telcom3") {{ winner.ssiConfecamara.telcom3 }}
            .detail-content.email
              span Correo:
              b {{ winner.ssiConfecamara.emailcom }}
            .detail-content.address
              span Dirección:
              b {{ winner.ssiConfecamara.dircom }}
            .detail-content.concurse
              span Concurso:
              b {{ concurso.name }}
</template>

<script>
export default {
  props: {
    winnerVal: String,
    concursoVal: String,
    rootVariable: String
  },
  data(){
    return {
      winner: null,
      concurso: null,
    }
  },
  computed:{
    getMatriculaDate(){
      return moment(this.winner.ssiConfecamara.fechamatricula).format("YYYY-MM-DD");
    },
    getRenovacionDate(){
      return moment(this.winner.ssiConfecamara.fecharenovacion).format("YYYY-MM-DD");
    }
  },
  mounted(){
    this.concurso = JSON.parse(this.concursoVal)
    this.winner = JSON.parse(this.winnerVal)
  }
}
</script>

<style lang="sass" scoped>
  .congrulations-text
    font-size: 35px
    font-weight: bold
    text-align: center
    margin-bottom: 30px
  .base-details-winner
    animation: fade .3s ease
    z-index: 1000
  .overflow-winner
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    background: rgba(0, 0, 0, 0.47)
    z-index: 3
    cursor: pointer
  .details-winner
    position: fixed
    width: 70%
    min-height: 70%
    background: #FFC107
    top: 50%
    left: 50%
    transform: translate(-50%, -50%) skewY(-5deg)
    z-index: 4
    padding: 50px
    border-radius: 50px
    font-size: 25px
    overflow: hidden
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 3px 10px rgba(0, 0, 0, 0.07)
    &:after
      content: ''
      position: absolute
      width: 200%
      height: 200%
      background: url(../../../images/lines.svg)
      top: 50%
      left: 50%
      z-index: -1
      background-repeat: no-repeat
      background-position: center
      transform: translate(-50%, -50%)
      animation: 60s moveBgLines ease infinite alternate
    & .name
      font-size: 28px
      font-weight: bold
      text-align: center
      margin-bottom: 30px
      background: rgb(75, 75, 75)
      border-radius: 3px
      color: #fff
  .card-details
    & .detail-content
      display: flex
      align-items: center
      &:before
        content: ''
        position: relative
        width: 30px
        height: 30px
        margin-right: 10px
        background-position: center !important
        background-size: contain !important
        background-repeat: no-repeat !important
      & span
        padding-right: 10px
      &.matr
        &:before
          background: url(../../../images/icons/enterprise.svg)
      &.id
        &:before
          background: url(../../../images/icons/id-card.svg)
      &.phones
        &:before
          background: url(../../../images/icons/call.svg)
      &.email
        &:before
          background: url(../../../images/icons/email.svg)
      &.address
        &:before
          background: url(../../../images/icons/compass.svg)
      &.concurse
        &:before
          background: url(../../../images/icons/medal.svg)
      &.dateAdd
        &:before
          background: url(../../../images/icons/calendar_add.svg)
      &.dateCheck
        &:before
          background: url(../../../images/icons/calendar_check.svg)
  .award
    display: flex
    justify-content: center
    align-items: center
  .bike-content
    width: 300px
  @keyframes moveBgLines
    from
      transform: translate(-50%, -50%) rotate(0deg)
    to
      transform: translate(-50%, -50%) rotate(360deg)
</style>



// WEBPACK FOOTER //
// resources/js/components/Winners2019/DetailsWinner.vue